import { unflatten } from 'flat'

/**
 * Transform form dotted object to classic object
 */
export const fromDotNotation = <T = any>(data: any) =>
  Array.isArray(data) ? data.map((d) => unflatten<any, T>(d)) : unflatten<any, T>(data)
